import GenePageTitleController from "../components/gene/GenePageTitleController";
import GeneUserInterface from "../components/gene/GeneUserInterface";

const Gene = () => {
  return <>
    <GenePageTitleController/>
    <GeneUserInterface/>
  </>;
};

export default Gene;
